import * as Yup from "yup";

export const newEtapa = Yup.object().shape({
    nome: Yup.string()
        .required("O nome da etapa é obrigatório")
        .max(50, "O nome deve ter no máximo 50 letras")
        .min(3, "O nome deve ter no mínimo 3 letras"),
})